import React, { useEffect } from 'react';
import './App.css';
import Navbar from './Components/Navbar';
import Facts from './Components/Facts';
import Footer from './Components/Footer';
import Copyright from './Components/Copyright';
import BackToTop from './Components/BackToTop';
import SmcMap from './Components/SmcMap';
import { Route, Routes, useLocation } from 'react-router';
import LandingPage from './pages/home/LandingPage';
import SubStations from './Components/SubStations';
import ParishAdmin from './Components/ParishAdmin';
import AboutChurch from './Components/AboutChurch';
import GalleryViewer from './pages/gallery/GalleryViewer';
import FlashNews from './pages/flashnews/FlashNews';
import AboutChurchNew from './Components/AboutChurchNew';
import Policy from './pages/policies/Policy';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Navbar />
      <main className="flex-grow-1">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/photo-gallery" element={<GalleryViewer />} />
          <Route path="/contact" element={<SmcMap />} />
          <Route
            path="/facts"
            element={
              <div className="page-container">
                <Facts />
              </div>
            }
          />
          <Route
            path="/substations"
            element={
              <div className="page-container">
                <SubStations />
              </div>
            }
          />
          <Route
            path="/parish-admin"
            element={
              <div className="page-container">
                <ParishAdmin />
              </div>
            }
          />
          <Route
            path="/history"
            element={
              <div className="page-container">
                <AboutChurch />
              </div>
            }
          />
        </Routes>
      </main>
      <Footer />
      <Copyright />
      <BackToTop />
    </div>
  );
}

export default App;
